import type { MigrationStrategies } from 'rxdb';
import type { PreviousReportFilesDocument } from './previousReports.types';

export const previousReportFilesMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: PreviousReportFilesDocument) => {
    const newDoc = {
      ...oldDoc,
    };
    delete newDoc.inspectorId;
    return newDoc;
  },
};
